export const pages = [
  {
    page: 'otpFormPage',
    percent: 0,
  },
  {
    page: 'otpVerifyCodePage',
    percent: 50,
  },
  {
    page: 'serviceMessagePage',
    percent: 100,
  },
];
